import { render, staticRenderFns } from "./ReviewPreview.vue?vue&type=template&id=fd818d6e&scoped=true&"
import script from "./ReviewPreview.vue?vue&type=script&lang=js&"
export * from "./ReviewPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPreview.vue?vue&type=style&index=0&id=fd818d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd818d6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
